import { useEffect } from 'react'
import { getDirectAffiliateLink } from '../config/site'

/**
s
 */
const AffiliateRedirect = () => {
  useEffect(() => {
    // Redirect to affiliate link immediately
    window.location.href = getDirectAffiliateLink()
  }, [])

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <p>Weiterleitung...</p>
    </div>
  )
}

export default AffiliateRedirect

